import React from 'react'
import ShopIntro from '../../components/shop/ShopIntro'
import ShopNavbar from '../../components/shop/ShopNavbar'
import ProductInfo from '../../components/shop/ProductInfo'
import BestProducts from '../../components/shop/BestProducts'
import ProductFeatures from '../../components/shop/ProductFeatures'
import Ask from '../../components/shop/Ask'
import ShopFooter from '../../components/shop/ShopFooter'
import OurBlogs from '../../components/shop/OurBlogs'
import { Helmet } from "react-helmet";

const Shop = () => {
  return (
    <div className='shop-page'>
      <Helmet>
            <meta charSet="utf-8" />
            <title>Adam Superfoods | Shop</title>
      </Helmet>
        <ShopNavbar/>
        <ShopIntro/>
        <ProductInfo/>
        <BestProducts/>
        <ProductFeatures/>
        <OurBlogs/>
        <Ask/>
        <ShopFooter/>
    </div>
  )
}

export default Shop